import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import { jsx as _jsx } from "react/jsx-runtime";
const ThemeProvider = ({
  children
}) => /*#__PURE__*/_jsx(ChakraProvider, {
  theme: theme,
  toastOptions: {
    defaultOptions: {
      position: 'top',
      variant: 'subtle',
      duration: 5000,
      isClosable: true
    }
  },
  children: children
});
export default ThemeProvider;